import { toast } from 'react-toastify';

import { BackendRoute } from '../../../../config/index';
import { QueryKey } from '../../../../constants/index';
import { useAppMutation, useInvalidateQueries } from '../../../../hooks/index';
import { ApiService } from '../../../../services/index';
import { CompanyIndustry } from '../../../../types/company.types';
import { PerkClaimDisplayRule, PerkClaimType, PerkOfferType } from '../perks.types';

export type AddPerkPayload = {
  applicableRegions?: string[];
  banner: string;
  claim:
    | {
        code: string;
        displayRule: PerkClaimDisplayRule;
        type: PerkClaimType.PROMO_CODE;
      }
    | {
        type: PerkClaimType.LINK;
        url: string;
      };
  companyDescription: string;
  companyName: string;
  companyShortDescription: string;
  contactPerson: string;
  industry: CompanyIndustry;
  logo: string;
  offerDescription: string;
  offerTypes: PerkOfferType[];
  url: string;
};

export const useAddPerk = () => {
  const { invalidateQuery } = useInvalidateQueries(QueryKey.PERKS);
  const { mutate: addPerk, isPending } = useAppMutation([QueryKey.PERKS, QueryKey.POST], {
    mutationFn: ({ data }: { data: AddPerkPayload }) =>
      ApiService.post(
        {
          endpoint: BackendRoute.PERKS,
        },
        { regularBackend: true, body: data },
      ),
    onSuccess: () => {
      invalidateQuery();
      toast.success('Perk created successfully');
    },
  });

  return {
    isPending,
    addPerk,
  };
};
